"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DetailDialogName = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _basisDialog = _interopRequireDefault(require("./basis-dialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DetailDialogName = 'detailDialog';
exports.DetailDialogName = DetailDialogName;

var DetailDialog = function DetailDialog(_ref) {
  var active = _ref.active,
      onCloseDialog = _ref.onCloseDialog,
      className = _ref.className,
      content = _ref.content,
      contentLabel = _ref.contentLabel,
      contentDescription = _ref.contentDescription,
      title = _ref.title,
      confirmText = _ref.confirmText,
      icon = _ref.icon;
  var actions = [/*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    key: "detailAction",
    raised: true,
    primary: true,
    className: "action-button detail-button",
    onClick: function onClick() {
      return onCloseDialog(true);
    }
  }, confirmText)];
  return /*#__PURE__*/_react["default"].createElement(_basisDialog["default"], {
    active: active,
    className: "detail-dialog ".concat(className),
    onCloseDialog: onCloseDialog,
    icon: icon,
    contentLabel: contentLabel,
    contentDescription: contentDescription,
    content: content,
    title: title,
    actions: actions
  });
};

DetailDialog.propTypes = {
  className: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  onCloseDialog: _propTypes["default"].func,
  content: _propTypes["default"].node,
  icon: _propTypes["default"].node,
  contentLabel: _propTypes["default"].node,
  contentDescription: _propTypes["default"].string,
  title: _propTypes["default"].node,
  confirmText: _propTypes["default"].node
};

var noop = function noop() {};

DetailDialog.defaultProps = {
  className: '',
  active: false,
  onCloseDialog: noop,
  content: '',
  icon: null,
  contentLabel: '',
  contentDescription: '',
  title: '',
  confirmText: ''
};
var _default = DetailDialog;
exports["default"] = _default;